import { KYMW2500Component } from './kymw2500.component';
import { GetPageCopyModel } from './vo/get-page-copy.model';
import { PagenationRequestModel } from './vo/pagenation-request.model';

/**
 * ページネーション設定画面の値を管理するクラス
 *
 * @export KYMW2500Model
 * @class KYMW2500Model
 */
export class KYMW2500Model {
  public kymw2500Component: KYMW2500Component = null;

  /**
   * データグリッド「ページネーション設定一覧」
   */
  public pagenationList: Array<any> = new Array<any>();

  /**
   * テキスト「使用開始 受注コード」
   */
  public orderCode: string = null;

  /**
   * テキスト 「グループ」
   */
  public group: string = null;

  /**
   * データグリッド「ページネーション詳細」
   */
  public pagenationDetail: Array<any>;

  /**
   * ページネーション詳細一覧をクリアするかフラグ
   * @memberof KYMW2500Model
   */
  public clearPageNationDetailFlg = false;

  /**
   * コンボボックス「基版ページ作成生協」で選択を確定したアイテムのインデックス
   */
  private coopCodeIndex: number = null;
  public coopCode: string = null;

  /**
   * ページネーション設定一覧取得条件
   */
  private getPageCopyVO: GetPageCopyModel = new GetPageCopyModel();

  /**
   * ページネーション詳細取得条件
   */
  private getPagenationDetailVO: PagenationRequestModel = new PagenationRequestModel();

  /**
   * ページネーション詳細の設定モード
   * "a"：追加  "e"：編集  ""：ページネーション詳細が非活性
   */
  private mode = String('');

  // カラム表示フラグ(基版)
  public visibleKihanPage = Boolean(false);
  // カラム表示フラグ(いばらき)
  public visibleIbarakiPage = Boolean(true);
  // カラム表示フラグ(とちぎ)
  public visibleTochigiPage = Boolean(true);
  // カラム表示フラグ(ぐんま)
  public visibleGunnmaPage = Boolean(true);
  // カラム表示フラグ(ちば)
  public visibleChibaPage = Boolean(true);
  // カラム表示フラグ(さいたま)
  public visibleSaitamaPage = Boolean(true);
  // カラム表示フラグ(とうきょう)
  public visibleTokyoPage = Boolean(true);
  // カラム表示フラグ(ながの)
  public visibleNaganoPage = Boolean(true);
  // カラム表示フラグ(にいがた)
  public visibleNiigataPage = Boolean(true);
  // カラム表示フラグ(クルコ)
  public visibleKurucoPage = Boolean(true);

  /**
   * データグリッド「ページネーション設定一覧」を設定する
   *
   * @param {*} serverData サーバからのレスポンスのデータ部分
   * @param {GetPageCopyModel} requestVO サーバへのリクエスト内容
   * @memberof KYMW2500Model
   */
  public updatePagenationList(serverData: any, requestVO: GetPageCopyModel): void {
    this.pagenationList = new Array<any>();

    // データをセット
    if (serverData != null) {
      // 1 件以上の場合
      const tempPagenationList: Array<any> = serverData;

      let pagenation: any = new Object();

      for (let i = Number(0); i < tempPagenationList.length; i++) {
        pagenation = new Object();
        pagenation.OrderCode = tempPagenationList[i].OrderCode;
        pagenation.DelivCatalogId = tempPagenationList[i].DelivCatalogId;
        pagenation.Group = tempPagenationList[i].Group;
        pagenation.CoopCode = tempPagenationList[i].CoopCode;
        pagenation.PlanCoopName = tempPagenationList[i].PlanCoopName;

        this.pagenationList.push(pagenation);
      }
    }

    // ページネーション設定一覧の取得条件を退避
    if (requestVO == null) {
      this.getPageCopyVO = new GetPageCopyModel();
    } else {
      this.getPageCopyVO = requestVO;
    }
  }

  /**
   * データグリッド「ページネーション詳細」を設定する
   *
   * @param {*} serverData サーバからのレスポンスのデータ部分
   * @param {PagenationRequestModel} requestVO サーバへのリクエスト内容
   * @memberof KYMW2500Model
   */
  public updatePagenationDetail(serverData: any, requestVO: PagenationRequestModel): void {
    this.pagenationDetail = new Array<any>();

    // データをセット
    if (serverData != null) {
      // 1 件以上の場合
      const tempPagenationDetail: Array<any> = serverData;

      let pagenationLine: any = new Object();

      for (let i = Number(0); i < tempPagenationDetail.length; i++) {
        pagenationLine = new Object();
        pagenationLine.KihanPage = this.decodeString(tempPagenationDetail[i].PageNo, '0', '未設定');
        pagenationLine.IbarakiPage = this.decodeString(tempPagenationDetail[i].IbarakiPage, '0', '未設定');
        pagenationLine.TochigiPage = this.decodeString(tempPagenationDetail[i].TochigiPage, '0', '未設定');
        pagenationLine.GunnmaPage = this.decodeString(tempPagenationDetail[i].GunnmaPage, '0', '未設定');
        pagenationLine.ChibaPage = this.decodeString(tempPagenationDetail[i].ChibaPage, '0', '未設定');
        pagenationLine.SaitamaPage = this.decodeString(tempPagenationDetail[i].SaitamaPage, '0', '未設定');
        pagenationLine.TokyoPage = this.decodeString(tempPagenationDetail[i].TokyoPage, '0', '未設定');
        pagenationLine.NaganoPage = this.decodeString(tempPagenationDetail[i].NaganoPage, '0', '未設定');
        pagenationLine.NiigataPage = this.decodeString(tempPagenationDetail[i].NiigataPage, '0', '未設定');
        pagenationLine.KurucoPage = this.decodeString(tempPagenationDetail[i].KurucoPage, '0', '未設定');

        this.pagenationDetail.push(pagenationLine);
      }
    }

    // ページネーション詳細の取得条件を退避
    if (requestVO == null) {
      this.getPagenationDetailVO = new PagenationRequestModel();
      this.pagenationDetail = new Array<any>();
    } else {
      this.getPagenationDetailVO = requestVO;
    }
  }

  /**
   * データグリッド「ページネーション設定一覧」から指定行を削除する
   *
   * @param {number} index 行（インデックス値）
   * @memberof KYMW2500Model
   */
  public deletePagenationListLine(index: number): void {
    const workList: Array<any> = this.pagenationList.concat();
    workList.splice(index, 1);
    this.pagenationList = workList;
  }

  /**
   * データグリッド「ページネーション詳細」の最終行に1行追加する
   *
   * @memberof KYMW2500Model
   */
  public addPagenationDetailLine(): void {
    if (this.pagenationDetail == null) {
      this.pagenationDetail = new Array<any>();
    }

    const pagenationLine: any = new Object();
    pagenationLine.KihanPage = '未設定';
    pagenationLine.IbarakiPage = '未設定';
    pagenationLine.TochigiPage = '未設定';
    pagenationLine.GunnmaPage = '未設定';
    pagenationLine.ChibaPage = '未設定';
    pagenationLine.SaitamaPage = '未設定';
    pagenationLine.TokyoPage = '未設定';
    pagenationLine.NaganoPage = '未設定';
    pagenationLine.NiigataPage = '未設定';
    pagenationLine.KurucoPage = '未設定';

    this.pagenationDetail = this.pagenationDetail.concat(pagenationLine);
  }

  /**
   * データグリッド「ページネーション詳細」から選択された行を削除する
   *
   * @param {number} selectedIndex 選択行インデックス
   * @memberof KYMW2500Model
   */
  public deletePagenationDetailLine(selectedIndex: number): void {
    const workList: Array<any> = this.pagenationDetail.concat();
    workList.splice(selectedIndex, 1);
    this.pagenationDetail = workList;
  }

  /**
   * データグリッド「ページネーション詳細」の行数を返す
   *
   * @returns {number}
   * @memberof KYMW2500Model
   */
  public getPagenationDetailLength(): number {
    if (this.pagenationDetail != null) {
      return this.pagenationDetail.length;
    } else {
      return 0;
    }
  }

  /**
   * データグリッド「ページネーション詳細」の指定セルの値を変更する
   *
   * @param {number} row 行（インデックス値）
   * @param {string} colomnName 列（インデックス名）
   * @param {string} value 値
   * @memberof KYMW2500Model
   */
  public setPagenationDetailCell(row: number, colomnName: string, value: string): void {
    this.pagenationDetail[row][colomnName] = value;
  }

  /**
   * データグリッド「ページネーション詳細」の表示を更新する（セルの値を変更後に使用）
   *
   * @memberof KYMW2500Model
   */
  public refreshPagenationDetail(): void {
    this.kymw2500Component.dtg_PagenationDetail.refresh();
  }

  /**
   * 指定生協のページネーション詳細リスト（データグリッド部）を返す。
   *
   * @param colomnName  列（インデックス名）
   * @return 指定した生協のページネーション詳細リスト
   */
  public getCoopPagenationDetailList(colomnName: string): Array<any> {
    const pageList: Array<any> = new Array<any>();

    // データをセット
    if (this.pagenationDetail != null) {
      for (let i = Number(0); i < this.pagenationDetail.length; i++) {
        pageList.push(this.decodeString(this.pagenationDetail[i][colomnName], '未設定', '0'));
      }
    }

    return pageList;
  }

  /**
   * ページネーション設定一覧の取得条件を返す
   *
   * @returns {GetPageCopyModel} ページネーション設定一覧の取得条件
   * @memberof KYMW2500Model
   */
  public getGetPageCopyVO(): GetPageCopyModel {
    return this.getPageCopyVO;
  }

  /**
   * ページネーション詳細の取得条件を返す
   *
   * @returns {PagenationRequestModel} ページネーション詳細の取得条件
   * @memberof KYMW2500Model
   */
  public getGetPagenationDetailVO(): PagenationRequestModel {
    return this.getPagenationDetailVO;
  }

  /**
   * 前回設定したコンボボックス「基版ページ作成生協」の選択内容のインデックス値を取得する
   *
   * @returns {number} 前回設定したインデックス値
   * @memberof KYMW2500Model
   */
  public getCoopCodeIndex(): number {
    return this.coopCodeIndex;
  }

  /**
   * コンボボックス「基版ページ作成生協」の選択内容のインデックス値を設定する
   *
   * @param {number} index コンボボックス「基版ページ作成生協」の選択アイテムのインデックス値
   * @memberof KYMW2500Model
   */
  public setCoopCodeIndex(index: number): void {
    this.coopCodeIndex = index;
  }

  /**
   * ページネーション詳細の設定モードを返す
   *
   * @returns {string} ページネーション詳細の設定モード
   * @memberof KYMW2500Model
   */
  public getMode(): string {
    return this.mode;
  }

  /**
   * ページネーション詳細の設定モードを設定する
   *
   * @param {string} mode 設定モード　"a":追加  "e":編集
   * @memberof KYMW2500Model
   */
  public setMode(mode: string): void {
    this.mode = mode;
  }

  /**
   * データグリッド「ページネーション設定一覧」に、指定の受注コード、及び生協コードのデータが存在するか否かを返す
   *
   * @param {string} targetOrderCode 適用開始受注コード
   * @returns {Boolean} true:存在する  false:存在しない
   * @memberof KYMW2500Model
   */
  public existsPagenationList(targetOrderCode: string): boolean {
    let result = false;

    if (this.pagenationList != null) {
      for (let i = Number(0); i < this.pagenationList.length; i++) {
        const orderCode: string = this.pagenationList[i]['OrderCode'];
        if (orderCode === targetOrderCode) {
          result = true;
          break;
        }
      }
    }

    return result;
  }

  /**
   * 対象がnullの場合、指定の文字列に置き換える
   *
   * @param {string} target 処理対象の文字列
   * @param {string} swap 置換する文字列
   * @returns {string} 置換後の文字列
   * @memberof KYMW2500Model
   */
  public decodeNullString(target: string, swap: string): string {
    let returnString: string = target;

    if (target == null) {
      returnString = swap;
    }

    return returnString;
  }

  /**
   * 対象が特定の文字列の場合、指定の文字列に置き換える
   *
   * @param {string} target 処理対象の文字列
   * @param {string} check 検索する文字列
   * @param {string} swap 置換する文字列
   * @returns {string} 置換後の文字列
   * @memberof KYMW2500Model
   */
  public decodeString(target: string, check: string, swap: string): string {
    let returnOrderCode: string = target;

    if (target === check) {
      returnOrderCode = swap;
    }

    return returnOrderCode;
  }

  /**
   * 選択されたページネーションのグループを返す
   *
   * @returns {string} ページネーション詳細の設定モード
   * @memberof KYMW2500Model
   */
  public getGroup(): string {
    return this.group;
  }

  /**
   * ページネーション詳細一覧に表示するグループを設定する
   *
   * @param {string} group 設定モード　"a":追加  "e":編集
   * @memberof KYMW2500Model
   */
  public setGroup(group: string): void {
    this.group = group;
  }

}
